import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Ensures every outgoing HTTP request sends and receives cookies by setting withCredentials: true.
 * Required so the XSRF-TOKEN cookie and any auth/session cookies work.
 */
export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req.clone({ withCredentials: true }));
};
